module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAc0lEQVQ4jWNgGGjAyMDAwLBp06b/uBTIJlXi1Gz45iojC4zj6+vLcPTwfgZrW0cURRcYcBvAwMDAwARjHD28n+HZk0cMRw/vJ+hsrAZY2zoySMnIYbiAaANghpAKmAgrGTWAEIAnpM2bN2NVIEupDYMfAAAOuhc5kBcjIwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MT.png
// module id = 1216
// module chunks = 0